
import React from 'react'
import { useAuth } from '../hooks/useAuth'
import { Card } from '../components/ui/Card'

// Map PMP membership_level values to display labels
function formatMembershipLevel(level?: string): string {
  if (!level) return 'Community Member'
  const map: Record<string, string> = {
    'community-member': 'Community Member',
    'Monthly Inner Circle': 'Monthly Inner Circle',
    'Yearly Inner Circle': 'Yearly Inner Circle',
    'Starter Week': 'Starter Week',
  }
  return map[level] ?? level
}

export function Settings() {
  const { user, profile } = useAuth()

  const membershipLabel = formatMembershipLevel(profile?.membership_level)

  return (
    <div className="max-w-3xl mx-auto space-y-8">
      <h1 className="text-2xl font-bold text-slate-900">Settings</h1>

      <Card>
        <h2 className="text-lg font-semibold text-slate-900 mb-4">
          Profile Information
        </h2>
        <div className="space-y-4">

          {/* Username */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Username
            </label>
            <input
              type="text"
              value={profile?.username || ''}
              readOnly
              className="w-full px-4 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-600 cursor-not-allowed"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              value={user?.email || ''}
              readOnly
              className="w-full px-4 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-600 cursor-not-allowed"
            />
          </div>

          {/* Membership Level */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Membership Plan
            </label>
            <div className="flex items-center gap-3">
              <input
                type="text"
                value={membershipLabel}
                readOnly
                className="flex-1 px-4 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-600 cursor-not-allowed"
              />
              <a
                href="https://wasabara.com/membership/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:text-blue-700 whitespace-nowrap"
              >
                Manage plan →
              </a>
            </div>
          </div>

          <p className="text-sm text-slate-500 pt-2">
            Profile information is managed through your Wasabara account and cannot be changed here.
          </p>
        </div>
      </Card>
    </div>
  )
}
